export default __webpack_public_path__ + "static/media/sb.2b5b35c4.svg";